<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png"
             alt="菜单">
      </div>
      <div class="caidan-title">
        单位管理
      </div>
    </div>
    <div v-if="!show">
      暂未开发
    </div>
      <div class="modul-btn" style="text-align: right;padding-right: 10px;">
        <el-button @click="addItem">新增</el-button>
      </div>
    <div class="modul-content"
         v-if="show">
      <el-table ref="multipleTable"
                :data="tableData"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :tree-props="{children: 'list',hasChildren: 'hasChildren'}"
                row-key="id"
                max-height="600"
                border
                style="width: 100%">
				<el-table-column label="排序"
				                 type="index">
				</el-table-column>
        <el-table-column label="单位名称"
                         prop="departmentName">
        </el-table-column>
        
        <el-table-column label="创建时间"
                         prop="createTime">
        </el-table-column>
        </el-table-column> -->
        <el-table-column label="操作">
          <template #default='scope'>
            <div>
              <el-button type="text"
                         @click="write(scope.row)">修改</el-button>
              <el-button type="text"
                         @click="shanChu(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    <el-dialog :visible.sync="addVisible"
               :modal-append-to-body="false"
               width="70%">
      <div class="modul-top1"
           slot="title">
        <div class="caidan-img">
          <img src="../../../assets/image/caidan.png"
               alt="菜单">
        </div>
        <div class="caidan-title">
          {{title}}
        </div>
      </div>
      <div style="text-align:left">
        <el-form :inline="true"
                 :rules="rules"
                 label-width="150px"
                 :model="dialogFormInline"
                 ref="ruleForm"
                 class="demo-form-inline">
          <el-row>
            <el-col :span="24">
              <el-form-item label="单位名称"
                            prop="departmentName">
                <el-input v-model="dialogFormInline.departmentName"
                          style="width: 460px;"
                          placeholder="请输入单位名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer"
            style="right: 20px;bottom: 20px;position: absolute;">
        <el-button type="primary"
                   @click="dialogSure()">确 定</el-button>
        <el-button @click="quXiao('ruleForm')">取 消</el-button>
      </span>
    </el-dialog>
  </div>
  </div>
</template>

<script>
export default {
  name: 'ZuijiBridegIndex',

  data () {
    return {
      show: true,
      // 表格
      tableData: [],
      // 分页器
      pagination: {
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 1, //当前页数
      },

      // addVisible
      title: '',
      addVisible: false,
      dialogFormInline: {},
      rules: {
        departmentName: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
      },
    };
  },

  mounted () {
	this.getDepartment()
  },

  methods: {
	  // 获取-部门名称列表
	  async getDepartment() {
	  	let data = {
	  		pageSize: 99999,
	  		pageNum: 1
	  	};
	  	const res = await this.$api.sendPost('/enterpriseDepartment/getAllEnterpriseTWO', data);
	  	console.log("部门名称", res);
	  	if (res.errcode == 0) {
	  		if (res.data && res.data.length > 0) {
	  			this.tableData = res.data;
	  		} else {
	  			this.tableData = [];
	  		}
	  	}
	  },
    // 新增
    addItem () {
		this.dialogFormInline={};
		this.addVisible=true
    },
    // 取消
    quXiao (formName) {
      this.addVisible = false;
      if (this.title == '添加单位') {
        this.$refs[formName].resetFields();
      }
    },
    // 新增确认
    async dialogSure () {
		this.addVisible = false;
		if (this.dialogFormInline.id!=undefined) {
			var data={
				departmentName:this.dialogFormInline.departmentName,
				id:this.dialogFormInline.id
			}
		} else{
			var data={
				departmentName:this.dialogFormInline.departmentName
			}
		}
		console.log(data);
		const res = await this.$api.sendPost('/enterpriseDepartment/insertOrUpdateEnterpriseDepartment',data);
		console.log(res);
		this.getDepartment()
    },
    // 导出
    exportItem () {

    },
    // 修改
    write (item) {
		this.addVisible=true
		this.dialogFormInline=item
    },
    // 删除
    shanChu (item) {
      console.log(item);
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
		  console.log('成功');
        this.$api.sendGet('/enterpriseDepartment/delete', { id: item.id }).then(res => {
			console.log(res);
          if (res.errcode == 0) {
            this.getDepartment()
			this.$message({ type: 'success', message: res.errmsg });
          } else {
			this.$message({ type: 'info', message: res.errmsg });
          }
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.el-input__inner {
//   border: none;
// }
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .modul-btn {
    margin-left: 50px;
  }
}
.zhuangtai {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 60px;
  margin: 0 auto;
  .dian {
    width: 6px;
    height: 6px;
    border: 2px solid;
    border-radius: 50%;
  }
}
/deep/.el-dialog {
  height: 800px;
}
</style>